<template>
  <div class="product_inf" style="">
    <card
      title="赔付承诺">
      <div class="product_inf_content" style="padding:0rem 2rem 0.6rem 1.8rem;">
        <span
          class="inlineblock width100 yellowfont minfont widthStyle"
          v-html="promiseOfPayout">
        </span>
        <span class="inlineblock width100 yellowfont minfont">
                  <span>&emsp;&emsp;赔付规则：</span>
                  <span>
                    <a
                      style="color:#ff0000"
                      @click="viewImg(compensationCommitmentAttachment)">查看</a>
                  </span>
                </span>

      </div>

    </card>
    <preview-modal ref="imageModal"></preview-modal>
  </div>
</template>

<script>
  import card from '@views/general/modules/Card.vue'
  import PreviewModal from './PreviewModal'

  export default {
    name: 'CompensationCommitment',
    components: { card, PreviewModal },
    props: {
      promiseOfPayout: {
        type: String,
        default: ''
      },
      compensationCommitmentAttachment: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        picture: [],
        logo: require('../../../assets/card/logo.png'),
        book: require('../../../assets/book.png'),
        reportData: [
          {
            name: '赔付规则',
            img: require('@assets/commit_book.png')
          }
        ]
      }
    },
    methods: {
      viewImg(url) {
        // 预览静态图片
        this.$refs.imageModal.show(url)
      }
    }
  }
</script>


<style lang="less" scoped>
.widthStyle {
  width: 18rem;
  word-wrap: break-word;
}

.bold-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70%;
  height: 30px;
  background: #FCE5C9;
  font-size: 20px;
  font-weight: bold;
  margin: 0 auto;
  margin-bottom: 10px;
}

.ant-carousel .slick-slide {
  text-align: center;
  height: 160px;
  line-height: 160px;
  background: #364d79;
  overflow: hidden;
}

.ant-carousel .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}

.ant-carousel .custom-slick-arrow:before {
  display: none;
}

.ant-carousel .custom-slick-arrow:hover {
  opacity: 0.5;
}

.ant-carousel .slick-slide h3 {
  color: #fff;
}


.product_inf {
  /* position: relative; */
  /* height: 7rem; */
  /* background: url(../images/Product_inf_bg.jpg); */
  width: 100%;
  height: 100%;
  margin: 3rem auto;
  top: 8rem;
}

.yellowfont {
  color: #faefac;
}

.width100 {
  width: 100%;
  padding: 0.2rem 0;
}

.inlineblock {
  display: inline-block;
}

.minfont {
  font-size: 1rem !important;
}
</style>
